import { useState, useEffect } from "react";
import { apiFetch } from "../services/api.js";
import CuponsCliente from "./CuponsCliente";

export default function TabelaClientes({ clientes }) {
  const [clientesComCupons, setClientesComCupons] = useState([]);
  const [modalAberto, setModalAberto] = useState(null);

  useEffect(() => {
    async function carregarCupons() {
      try {
        const campanhasRes = await apiFetch("campanhas");
        const campanhasAtivasIds = (campanhasRes?.campanhas || [])
          .filter((c) => c.ativo !== false && c.arquivado !== true)
          .map((c) => c.id);

        const clientesInfo = await Promise.all(
          clientes.map(async (cliente) => {
            try {
              const res = await apiFetch(`cupons/cliente/${cliente.id}`);
              const cuponsAtivos = (res.cupons || []).filter((cupom) =>
                campanhasAtivasIds.includes(cupom.campanha_id),
              );
              return {
                ...cliente,
                quantidadeCupons: cuponsAtivos.length,
              };
            } catch (err) {
              console.error(
                `Erro ao carregar cupons do cliente ${cliente.id}:`,
                err,
              );
              return { ...cliente, quantidadeCupons: 0 };
            }
          }),
        );
        setClientesComCupons(clientesInfo);
      } catch (err) {
        console.error("Erro ao carregar campanhas:", err);
        const clientesInfo = await Promise.all(
          clientes.map(async (cliente) => {
            try {
              const res = await apiFetch(`cupons/cliente/${cliente.id}`);
              return {
                ...cliente,
                quantidadeCupons: res.cupons ? res.cupons.length : 0,
              };
            } catch (err2) {
              return { ...cliente, quantidadeCupons: 0 };
            }
          }),
        );
        setClientesComCupons(clientesInfo);
      }
    }

    if (clientes.length > 0) {
      carregarCupons();
    }
  }, [clientes]);

  if (!clientesComCupons.length) {
    return null;
  }

  return (
    <div>
      <h3>Clientes Cadastrados</h3>
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>CPF/CNPJ</th>
            <th>Cupons</th>
            <th>Ação</th>
          </tr>
        </thead>
        <tbody>
          {clientesComCupons.map((c) => (
            <tr key={c.id}>
              <td>{c.nome}</td>
              <td>{c.documento || c.cpf_cnpj}</td>
              <td>
                <strong>{c.quantidadeCupons}</strong>
              </td>
              <td>
                <button
                  onClick={() => setModalAberto(c.id)}
                  style={{
                    backgroundColor: "#667eea",
                    color: "white",
                    border: "none",
                    padding: "0.4rem 0.8rem",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Ver Cupons
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalAberto && (
        <CuponsCliente
          clienteId={modalAberto}
          onClose={() => setModalAberto(null)}
        />
      )}
    </div>
  );
}
